export default __webpack_public_path__ + "static/media/286.e5b073e7.jpg";